import { render } from "./actualizaciones.vue?vue&type=template&id=157674e7&scoped=true"
import script from "./actualizaciones.vue?vue&type=script&lang=js"
export * from "./actualizaciones.vue?vue&type=script&lang=js"

import "./actualizaciones.vue?vue&type=style&index=0&id=157674e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157674e7"]])

export default __exports__